export default "__VITE_ASSET__DpbM0iFD__"